import React from "react";
import FormGenHi from "../components/Form";
import hipladeTemplate from "../../common/template";

function GenHiForm() {
  return <FormGenHi />;
}

export default hipladeTemplate(GenHiForm);
